import React from 'react';

export default function SectionHeading({ children }) {
  return <h5 className="fw-bold mb-3 mt-2">{children}</h5>;
}
